import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@root/environments/environment';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';

export function accessTokenInterceptor(
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  if (
    request?.url?.startsWith(environment.apiUrl) ||
    request?.url?.startsWith(environment.reportManagerUrl) ||
    request?.url?.startsWith(environment.rbacApiUrl)
  ) {
    const authService = inject(AuthenticationService);
    return authService.getAccessToken$().pipe(
      take(1),
      switchMap((token: string) => {
        if (token) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
              // eslint-disable-next-line @typescript-eslint/naming-convention
              'Content-Type': 'application/json',
            },
          });
        }
        return next(request);
      })
    );
  }
  return next(request);
}
